import LocationTypeFilterContainer from './LocationTypeFilterContainer';

export default LocationTypeFilterContainer;
